<template>
  <Modal
    v-model="_value"
    width="500"
    title="添加保险渠道"
    @on-visible-change="visibleChange"
    ok-text="添加"
    @on-ok="onOk">
    <Form ref="loginForm" :model="insurancechannel" :rules="rules" >
      <FormItem prop="name">
        <Input v-model="insurancechannel.name" placeholder="请输入保险渠道名称">
        </Input>
      </FormItem>
      <FormItem prop="telephoneNum">
        <Input v-model="insurancechannel.telephoneNum" placeholder="请输入联系电话">
        </Input>
      </FormItem>
      <FormItem prop="address">
        <Input v-model="insurancechannel.address" placeholder="请输入联系地址">
        </Input>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'AddInsurancechannelInfoModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null,
      nameRules: {
        type: Array,
        default: () => {
          return [
            { required: true, message: '保险渠道名称不能为空', trigger: 'blur' }
          ]
        }
      },
    },
    data() {
      return {
        insurancechannel: {
          name:null,
          telephoneNum:null,
          address:null,
          lat:null,
          lng:null,
        }
      }
    },
    methods: {
      ...mapActions([
        'SalesChannelServ_AddObj'
      ]),
      onOk() {
        this.$Modal.confirm({
          title: '添加用户信息',
          content: '<p>是否确认添加用户信息</p>',
          onOk: () => {
            store.dispatch('InsuranceChannelServ_AddObj', {params: this.insurancechannel}).then(() => {
              this.$Message.success('添加保险渠道成功')
              this.$emit('on-success');
            }).catch(err => {
              this.$Message.error(err)
              this.$emit('on-fail');
            })
          },
          onCancel: () => {
          }
        })
      },
      visibleChange(val) {
        if(val){
          this.insurancechannel.name = null
          this.insurancechannel.telephoneNum = null
          this.insurancechannel.address = null
          this.insurancechannel.lat = null
          this.insurancechannel.lng = null
        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      rules () {
        return {
          name: this.nameRules,
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
